import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePaymentAccessScope } from "../hook/usePaymentAccessScope";
import {
  canViewPaymentDashboard,
  DEFAULT_PAYMENT_DASHBOARD_VIEW_ROLES,
} from "./paymentDashboardAccess";

const PaymentProviderRouteContent = ({
  Component,
  allowedViewRoles,
  providerRole,
  routeProps,
}) => {
  const { currentUser } = useAuth();
  const { loading, canManagePayments } = usePaymentAccessScope(providerRole);
  const currentRoles = Array.isArray(currentUser && currentUser.roles)
    ? currentUser.roles
    : [];
  const canViewDashboard = canViewPaymentDashboard(
    currentRoles,
    canManagePayments,
    allowedViewRoles,
  );

  if (!currentUser) {
    return <Redirect to="/page-login" />;
  }

  if (loading) {
    return <div className="text-muted p-3">Checking payment access…</div>;
  }

  return canViewDashboard ? <Component {...routeProps} /> : <Redirect to="/" />;
};

const PaymentProviderRoute = ({
  component: Component,
  providerRole,
  allowedViewRoles = DEFAULT_PAYMENT_DASHBOARD_VIEW_ROLES,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <PaymentProviderRouteContent
          Component={Component}
          allowedViewRoles={allowedViewRoles}
          providerRole={providerRole}
          routeProps={routeProps}
        />
      )}
    />
  );
};

export default PaymentProviderRoute;
